import Icon from '../components/Icon.vue'

Icon.register({
  swatchbook: {
    width: 511,
    height: 512,
    paths: [
      {
        d: 'M479.1 320H372.3L186.2 506.5C184.1 508.6 181.7 510.1 179.5 512H479.1C496.7 512 511 497.7 511 480V352C511 334.3 496.7 320 479.1 320zM434.6 167.1L344.2 76.6C331.8 64.1 311.5 64.1 299.1 76.6L223.6 152.2V416C223.6 419 222.9 421.7 222.7 424.6L434.6 212.4C447 199.9 447 179.6 434.6 167.1zM191.6 32C191.6 14.3 177.3 0 159.7 0H31.9C14.3 0 0 14.3 0 32V416C0 469 42.9 512 95.8 512S191.6 469 191.6 416V32zM95.8 440C82.6 440 71.9 429.3 71.9 416 71.9 402.7 82.6 392 95.8 392S119.8 402.7 119.8 416C119.8 429.3 109 440 95.8 440zM127.8 256H63.9V192H127.8V256zM127.8 128H63.9V64H127.8V128z'
      }
    ]
  }
})
